
const useSearchParams = (search: string) => {
    const searchParamsInstance = new URLSearchParams(search);

    const getSearchParam = (paramName?: string) => {
        if (paramName) {
            const paramValues = searchParamsInstance.getAll(paramName);
            return paramValues.length <= 1 ? paramValues[0] : paramValues;
        }
        const searchParamKeys = [...new Set(searchParamsInstance.keys())];
        const searchParams = {};
        for (const key of searchParamKeys) {
            const value = searchParamsInstance.getAll(key);
            searchParams[key] = value.length <= 1 ? value[0] : value;
        }
        return searchParams;
    };

    return {
        searchParamsInstance,
        getSearchParam
    };
};

export default useSearchParams;